import { createContext, useContext, useState, ReactNode } from "react";
import Modal from "@components/modal";

interface ModalOptions {
  width?: string | number;
  padding?: string;
  height?: string;
}

interface ModalInstance {
  id: string;
  content: ReactNode;
  options: ModalOptions;
}

const ModalContext = createContext<{
  showModal: (content: ReactNode, options?: ModalOptions) => void;
  hideModal: () => void;
  modals: ModalInstance[];
}>({
  showModal: () => {},
  hideModal: () => {},
  modals: [],
});

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [modals, setModals] = useState<ModalInstance[]>([]);

  const showModal = (
    modalContent: ReactNode,
    modalOptions: ModalOptions = {}
  ) => {
    const id = Math.random().toString(36).substring(7);
    setModals((prev) => [...prev, { id, content: modalContent, options: modalOptions }]);
  };

  const hideModal = () => {
    setModals((prev) => prev.slice(0, -1));
  };

  return (
    <ModalContext.Provider value={{ showModal, hideModal, modals }}>
      {children}
      {modals.map((modal) => (
        <Modal
          key={modal.id}
          visible={true}
          onClose={hideModal}
          width={modal.options.width}
          height={modal.options.height}
          padding={modal.options.padding}
        >
          {modal.content}
        </Modal>
      ))}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
